import getLocaleData from 'src/internal/getLocaleData';

import type {IReports} from '@sail/observability';
import type {IntlConfig, Locale} from 'src/types';

export default function mergeOptions<
  Defaults extends {locale: Locale},
  Options extends Record<string, unknown>,
  Overrides extends Record<string, unknown>,
>(
  config: IntlConfig,
  defaults: Defaults,
  reports: IReports,
  userOptions?: Options,
  overrideOptions?: Overrides,
): Options & Defaults {
  const mergedOptions: Options & Defaults = Object.assign(
    {},
    defaults,
    userOptions,
    overrideOptions,
  );

  const resultingLocale: Locale = getLocaleData(
    mergedOptions.locale,
    config,
    reports,
  ).locale;

  return Object.assign(mergedOptions, {
    locale: resultingLocale,
  });
}
